import { makeStyles } from '@material-ui/styles';
import React, { useState, useEffect } from 'react';
import 'date-fns';
import clsx from 'clsx';
import {
  Backdrop, Card, CardHeader, Paper, Input, FormControl, Divider, Typography, Table, TableRow, TableCell,
  TableBody, TableContainer,
  IconButton, InputLabel, Select, InputAdornment, TextField, Button, CardContent, CircularProgress,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Container, colors
} from "@material-ui/core";
import Header from 'src/components/Header';
import CropFreeIcon from '@material-ui/icons/CropFree';
import SearchIcon from '@material-ui/icons/Search';
import axios from 'src/utils/axios';
import Page from 'src/components/Page';
import BarkodPopup from 'src/components/BarcodePopup';
import { getUser } from 'src/utils/Common';
import Alert from '@material-ui/lab/Alert';
import ConcealableContainer from 'src/components/ConcealableContainer';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  success: {
    backgroundColor: colors.green[600],
    color: theme.palette.common.white
  },
  info: {
    backgroundColor: colors.lightBlue[600],
    color: theme.palette.common.white
  },
  warning: {
    backgroundColor: colors.yellow[900],
    color: theme.palette.common.white
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText
  },
  root: {
    paddingTop: theme.spacing(3),
    flexGrow: 1
  },
  TableCellHeader: {
    backgroundColor: '#eee',
    fontWeight: 'bold',
    width: '5%',
    align: 'left'
  },
  cardHeader: {
    flexGrow: 1
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  searchDF: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconDF: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputDF: {
    flexGrow: 1
  },
  fieldsGaranti: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  contentGaranti: {
    minHeight: 430,
  },
  submitButtonAeee: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));


function AeeeUrunEsle({ className }) {
  const classes = useStyles();
  const user = getUser();
  const [Loading, setLoading] = useState(false);
  const [urunAlindi, setUrunAlindi] = useState(false);
  const [atikUrun, setAtikUrun] = useState(0);
  const [atikMarka, setAtikMarka] = useState(0);
  const [aeeeNot, setAeeeNot] = useState("");
  const [aeeeEtiket, setAeeeEtiket] = useState("");
  const [atikUrunData, setAtikUrunData] = useState([]);
  const [atikMarkaData, setAtikMarkaData] = useState([]);
  const [openBarkod, setOpenBarkod] = useState(false);
  const [searchService, setSearchService] = useState("");
  const [searchDealer, setSearchDealer] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchProduct, setSearchProduct] = useState("");
  const [searchParo, setSearchParo] = useState("");
  const [searchAeee, setSearchAeee] = useState("");
  const [searchServiceShopId, setSearchServiceShopId] = useState(0);
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");
  const [FisNo, setFisNo] = React.useState(0);
  const [isClickDisable, setIsClickDisable] = React.useState(false);

  useEffect(() => {
    let isMounted = true;

    axios.get('/GetArtemisAeeeUrun').then((response) => {
      if (isMounted) {
        const AeeeUrun = response.data;
        if (AeeeUrun.length === 0) {
          setAtikUrunData([]);
        } else {
          setAtikUrunData(AeeeUrun);
        }
      }
    }).catch(error => {
      logger.error("Aeee Urun error:", error.message);
    });

    axios.get('/GetArtemisAeeeMarka').then((response) => {
      if (isMounted) {
        const AeeeMarka = response.data;
        if (AeeeMarka.length === 0) {
          setAtikMarkaData([]);
        } else {
          setAtikMarkaData(AeeeMarka);
        }
      }
    }).catch(error => {
      logger.error("Aeee Marka error:", error.message);
    });

    return () => {
      isMounted = false;
    };
  }, []);
  const handleEventSearchChange = (value) => { 
    setFisNo(value); 
    setAtikUrun(0);
    setAtikMarka(0);
    setAeeeNot("");
    setAeeeEtiket("");
    setUrunAlindi(false); 
    setIsClickDisable(false);
  }
  const handleChangeAtikUrun = (event) => setAtikUrun(event.target.value || 0);
  const handleChangeAtikMarka = (event) => setAtikMarka(event.target.value || 0);
  const handleChangeAeeeNot = (event) => setAeeeNot(event.target.value || "");
  const handleChangeAeeeEtiket = (event) => setAeeeEtiket(event.target.value || "");
  const handleBarkodOpen = () => setOpenBarkod(true);
  const handleBarkodClose = async (barkod) => {
    setOpenBarkod(false);
    if (barkod.length === undefined) {
      return;
    }
    setAeeeEtiket(barkod);
  }
  const handleClose = () => {
    setOpen(false);
  };
  const matchServicePaper = () => {
    setIsClickDisable(true);
    const data = {
      FisNo: FisNo,
      UrunAlindi: "1",
      Etiket: aeeeEtiket,
      Urun: atikUrun,
      Marka: atikMarka,
      Notlar: aeeeNot,
      TeknisyenKodu: user.TechnicianId,
      BirimKodu: user.ServiceShopId,
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisAeeeEslenikFisOlustur', JSON.stringify(data), config).then((response) => {
      setLoading(false);
      const res = response.data;
      if (parseInt(res.ErrorCode) !== 0) {
        setUyari(res.ErrorDescription);
        setOpen(true);
      } else {
        setUyari("İşleminiz gerçekleştirildi.Okuttuğunuz AEEE barkodunu eski ürünün üzerine yapıştırmayı unutmayınız!...");
        setOpen(true);
      }
    })
  }
  const searchServicePaper = () => {
    if (FisNo.length === 9) {
      axios.get(`GetServicePaperForAeeeMatching/${FisNo}`).then((response) => {
        const AeeeFis = response.data[0];
        if (AeeeFis.ErrorCode === 0) {
          setSearchService(AeeeFis.Service);
          setSearchDealer(AeeeFis.Dealer);
          setSearchCustomer(AeeeFis.Customer);
          setSearchProduct(AeeeFis.Product);
          setSearchParo(AeeeFis.Paro);
          setSearchServiceShopId(AeeeFis.ServiceShopId);
          setSearchAeee(AeeeFis.Aeee);
          setUrunAlindi(true);
        } else {
          setUyari(AeeeFis.ErrorDescription);
          setOpen(true);
        }
      });
    }
    else {
      setUyari("Fis No Kontrol Ediniz!");
      setOpen(true);
    }
  }
  return (
    <Page className={classes.root} title="Aeee Fiş Eşleme">
      <Container maxWidth="lg">
        <Header />
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {Uyari}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
        <Card
          className={clsx(classes.cardHeader, className)}
        >
          <CardHeader title="Aeee İşlemleri" />
          <Divider />
          {
            Loading ?
              <Backdrop className={classes.backdrop} open={Loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
              : <div></div>
          }
          <CardContent>
            <Typography className={classes.title} color="textSecondary" component="span">
              <Paper
                className={classes.searchDF}
                elevation={1}>
                <Input
                  className={classes.searchInputDF}
                  disableUnderline
                  onChange={event => { handleEventSearchChange(event.target.value) }}
                  placeholder="Nakliye/Montaj Fiş No"
                />
                <SearchIcon onClick={() => searchServicePaper()} className={classes.searchIconB} />
              </Paper>
            </Typography>
            <Divider />
            {
              urunAlindi
              &&
              <div>
                <FormControl variant="outlined" className={classes.submitButtonAeee}>
                  <TableContainer component={Paper} >
                    <Table className={classes.table} aria-label="simple table">
                      <TableBody>
                        <TableRow >
                          <TableCell className={(searchParo === "Var") ? classes.success : classes.error} >{"Paro"}</TableCell>
                          <TableCell className={(searchParo === "Var") ? classes.success : classes.error} >{searchParo}</TableCell>
                        </TableRow>
                        <TableRow >
                          <TableCell className={(searchAeee === "Var") ? classes.success : classes.error} >{"Eski Al"}</TableCell>
                          <TableCell className={(searchAeee === "Var") ? classes.success : classes.error} >{searchAeee}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.TableCellHeader}>{"Servis"}</TableCell>
                          <TableCell align="left">
                            <span style={{ color: (searchServiceShopId !== user.ServiceShopId) ? 'red' : 'none' }}>
                              {searchService}
                            </span>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.TableCellHeader}>{"Bayi"}</TableCell>
                          <TableCell align="left">{searchDealer}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.TableCellHeader}>{"Müşteri"}</TableCell>
                          <TableCell align="left">{searchCustomer}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.TableCellHeader}>{"Ürün"}</TableCell>
                          <TableCell align="left">{searchProduct}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </FormControl>
                <Divider />
                <FormControl variant="outlined" className={classes.submitButtonAeee}>
                  <TextField
                    name="AeeeEtiket"
                    label={"AEEE Etiket"}
                    value={aeeeEtiket || ''}
                    onChange={e => handleChangeAeeeEtiket(e)}
                    fullWidth
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <IconButton color="primary" aria-label="settings" onClick={handleBarkodOpen} >
                            <CropFreeIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </FormControl>
                <FormControl variant="outlined" className={classes.submitButtonAeee}>
                  <InputLabel id="demo-simple-select-outlined-label" >{"AEEE Urun"}</InputLabel>
                  <Select
                    fullWidth
                    native
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    onChange={handleChangeAtikUrun}
                    label={"AEEE Ürün"}
                    hidden={true}
                    value={atikUrun}
                  >
                    <option value="" defaultValue></option>
                    {atikUrunData.map(p => {
                      return <option key={p.ModelKodu} value={p.ModelKodu}>{p.AtikUrun}</option>
                    })}
                  </Select>
                </FormControl>
                <FormControl variant="outlined" className={classes.submitButtonAeee}>
                  <InputLabel id="demo-simple-select-outlined-label" >{"AEEE Marka"}</InputLabel>
                  <Select
                    fullWidth
                    native
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    onChange={handleChangeAtikMarka}
                    label={"AEEE Marka"}
                    hidden={true}
                    value={atikMarka}
                  >
                    <option value="" defaultValue></option>
                    {atikMarkaData.map(p => {
                      return <option key={p.MarkaKodu} value={p.MarkaKodu}>{p.AtikMarka}</option>
                    })}
                  </Select>
                </FormControl>
                <FormControl variant="outlined" className={classes.submitButtonAeee}>
                  <TextField
                    name="AeeeNot"
                    label={"Notlar"}
                    value={aeeeNot || ''}
                    onChange={handleChangeAeeeNot}
                    fullWidth
                    variant="outlined"
                  />
                </FormControl> 
                <br />
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitButtonAeee}
                  onClick={matchServicePaper}
                  disabled={isClickDisable}
                >
                  Eşlenİk Fİş Oluştur
                        </Button>
                <BarkodPopup
                  onClose={handleBarkodClose}
                  open={openBarkod}
                  ScanTime={0}
                  CallScreen={0}
                />
                {
                  (searchServiceShopId !== user.ServiceShopId && urunAlindi)
                  && <div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                  </div>}
              </div>
            }
          </CardContent>
        </Card>
      </Container>
      <ConcealableContainer show={searchServiceShopId !== user.ServiceShopId && urunAlindi}>
        <Alert severity="warning">{"DİKKAT! Farklı Servise ait Fiş ile eşleme yapıyorsunuz."}</Alert>
      </ConcealableContainer>
    </Page >
  );
}

export default AeeeUrunEsle;
